export enum GardeModelAccess {
    FULL,
    ONESELF,
    NONE,
}
